var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '../styled-components';
var ItemDescription = styled.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 0.75rem;\n  margin: 0;\n"], ["\n  font-size: 0.75rem;\n  margin: 0;\n"])));
export default ItemDescription;
var templateObject_1;
